import { without } from 'lodash-es'

import { MOST_POPULAR_KINDS, NON_EXCLUSIVE_LOCATIONS, OTHER_KINDS, PHONE_CALL_KINDS } from '../constants'

const hasInboundPhone = (kinds) => kinds.includes(PHONE_CALL_KINDS.inbound)
const hasOutboundPhone = (kinds) => kinds.includes(PHONE_CALL_KINDS.outbound)

export const useAvailableKinds = (possibleKinds, activeLocations) => {
  let kinds = [...possibleKinds]
  if (hasInboundPhone(kinds) && hasOutboundPhone(kinds)) {
    kinds = without(kinds, PHONE_CALL_KINDS.inbound)
  }
  const phoneKinds = Object.values(PHONE_CALL_KINDS)

  let takenKinds = activeLocations.map(({ kind }) => kind)
  if (hasInboundPhone(takenKinds) || hasOutboundPhone(takenKinds)) {
    takenKinds = [...takenKinds, ...phoneKinds]
  }

  const filteredPossibleKinds = kinds.filter((kind) => !takenKinds.includes(kind) || NON_EXCLUSIVE_LOCATIONS.includes(kind))

  const mostPopularLocations = MOST_POPULAR_KINDS
    .filter((kind) => filteredPossibleKinds.includes(kind))
    .map((location) => ({
      type: 'location',
      value: location
    }))

  const definedKinds = [...MOST_POPULAR_KINDS, ...OTHER_KINDS]

  const otherLocations = OTHER_KINDS
    .filter((kind) => filteredPossibleKinds.includes(kind))
    .map((location) => ({
      type: 'location',
      value: location
    }))

  const additionalLocations = filteredPossibleKinds
    .filter((kind) => !definedKinds.includes(kind))
    .map((location) => ({
      type: 'location',
      value: location
    }))

  otherLocations.push(...additionalLocations)

  return [
    { type: 'divider', value: 'most_popular' },
    ...mostPopularLocations,
    { type: 'divider', value: 'other' },
    ...otherLocations,
  ]
}
